import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register service worker for auto-update functionality
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service Worker registered successfully:", registration);

        // Listen for version update messages from service worker
        navigator.serviceWorker.addEventListener("message", (event) => {
          if (event.data && event.data.type === "VERSION_UPDATE") {
            console.log(
              "Version update received from service worker:",
              event.data.version
            );

            // Don't automatically reload - let the version manager handle it
            // Just dispatch the event for the version manager to pick up
            window.dispatchEvent(
              new CustomEvent("versionUpdate", {
                detail: { version: event.data.version },
              })
            );
          }
        });
      })
      .catch((error) => {
        console.log("Service Worker registration failed:", error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
